<template>
	<div class="new-table-view">
		<div class="header" :style="{gridTemplateColumns: _gridTemplateCols}">
			<div :class="{ column: true, slim: slim }" v-if="value !== null">
				<check-view style="margin-top: 23px;" @input="checkAll" :value="value && items && value.length == items.length && items.length > 0" />
			</div>
			<div :class="{ column: true, slim: slim }" v-for="(col, c) in _columns" v-bind:key="c" :style="{textAlign: col.align}">{{ col.label }}</div>
		</div>
		<perfect-scrollbar class="body">
			<transition-group appear name="item" v-if="items !== null && items.length > 0">
				<component :is="draggable ? 'drag' : 'div'" :payload="{ type: draggable, data: items[i] }" class="item" v-for="(item, i) in _items" v-bind:key="i" :style="{gridTemplateColumns: _gridTemplateCols, transitionDelay: (i * 20) + 'ms'}" @click="$emit('itemClick', items[i], $event)">
					<div v-if="value !== null" :class="{ cell: true, slim: slim }">
						<check-view style="margin-top: 24px;" :value="value.find(function (itm) { return itm.id == items[i].id; }) !== undefined" @input="check" :data="items[i]" />
					</div>
					<div :class="{ cell: true, slim: slim }" v-for="(col, c) in _columns" v-bind:key="c" :style="{textAlign: col.align}">
						<span v-if="!col.template">{{ item[c][col.name] }}</span>
						<div class="profile" v-if="col.template && col.template.name == 'profile'">
							<div class="photo">
								<img :src="item[c]['photo']" />
							</div>
							<div class="name">{{ item[c]['name'] }}</div>
							<div class="title">{{ item[c]['title'] }}</div>
						</div>
						<div v-if="col.template && col.template.name == 'button'">
							<button-view emphasis="outlined" style="display: inline-block; line-height: 10px;" :label="col.template.label" @click="$emit(col.name.toString(), items[i], $event)">{{ col.template.label }}</button-view>
						</div>
						<div class="status subtitle" v-if="col.template && col.template.name == 'status' && item[c]['subtitle']" :title="item[c]['description']">
							<div class="dot" :style="{ backgroundColor: item[c]['color'] }"></div>
							<span class="title">{{ item[c][col.name] }}</span>
							<span class="subtitle">{{ item[c]['subtitle'] }}</span>
						</div>
						<div class="status" v-if="col.template && col.template.name == 'status' && !item[c]['subtitle']" :title="item[c]['description']">
							<div class="dot" :style="{ backgroundColor: item[c]['color'] }"></div>
							<span>{{ item[c][col.name] }}</span>
						</div>
						<div class="leave" v-if="col.template && col.template.name == 'leave'">
							<span :style="{ backgroundColor: item[c]['color'] }" @click.stop="$emit('leave', $event, item[c]['id'], item[c]['day'])">{{ item[c]['label'] }}</span>
						</div>
					</div>
				</component>
			</transition-group>	
		</perfect-scrollbar>
		<div v-if="items !== null && items.length == 0" class="state">
			Intet at vise
		</div>
		<div v-if="items === null" class="state" style="pointer-events: none;">
			<spinner-view />
		</div>
		<svgicon v-for="(action, i) in actions" :key="i" :style="{
			cursor: 	'pointer',
			position: 	'absolute', 
			top: 		'20px',
			right: 		(20 + (20 + 16) * i) + 'px',
			width: 		'16px', 
			height: 	'16px'
		}" @click="$emit(action.name)" :icon="action.icon" />
	</div>
</template>

<script>
	export default {
		data: function () {
			return {

			};
		},
		props: {
			columns: {
				type: Array,
				default: function () {
					return [];
				}
			},
			items: {
				type: Array,
				default: function () {
					return [];
				}
			},
			index: {
				type: String,
				default: 'id'
			},
			slim: {
				type: Boolean,
				default: false
			},
			value: {
				type: Array,
				default: function () {
					return null;
				}
			},
			actions: {
				type: Array,
				default() {
					return [];
				}
			},
			draggable: {
				type: String,
				default: null
			}
		},
		watch: {
			items() {
				if (this.value !== null) this.$emit('input', []);
			}
		},
		computed: {
			_items() {
				var r = [];

				for (var i = 0; i < this.items.length; ++i) {
					r.push(this.normalizeItem(this.items[i]));
				}

				//console.log(r);

				return r;
			},
			_columns() {
				var r = [];

				for (var i = 0; i < this.columns.length; ++i) {
					r.push(this.normalizeColumn(this.columns[i]));
				}

				return r;
			},
			_gridTemplateCols() {
				var r = [];
				var col;

				if (this.value !== null) r.push('100px');

				for (var i = 0; i < this._columns.length; ++i) {
					col = this._columns[i];
					r.push(isNaN(col.weight) ? col.weight : col.weight + 'fr');
				}

				return r.join(' ');
			}
		},
		methods: {
			checkAll(v) {
				console.log('check all', v);

				this.$emit('input', v ? Array.from(this.items) : []);
			},
			check(v, item) {
				console.log('check', v, item);

				var pos = this.value.findIndex(function (itm) { return itm.id == item.id; });
				var r = Array.from(this.value);

				console.log('pos', pos);

				if (pos < 0) { r.push(item); } else { r.splice(pos, 1); }

				console.log('value', r);

				this.$emit('input', r);
			},
			normalizeColumn(col) {
				if (!col.hasOwnProperty('name')) 		col['name'] = [];
				if (!col.hasOwnProperty('filter')) 		col['filter'] = null;
				if (!col.hasOwnProperty('prefix')) 		col['prefix'] = '';
				if (!col.hasOwnProperty('suffix')) 		col['suffix'] = '';
				if (!col.hasOwnProperty('weight')) 		col['weight'] = 1;
				if (!col.hasOwnProperty('component')) 	col['component'] = null;
				if (!col.hasOwnProperty('template')) 	col['template'] = null;
				if (!col.hasOwnProperty('data')) 		col['data'] = null;
				if (!col.hasOwnProperty('align')) 		col['align'] = 'left';
				if (!col.hasOwnProperty('default')) 	col['default'] = '-';
				if (!col.hasOwnProperty('translation'))	col['translation'] = null;

				if (!Array.isArray(col.name)) {
					col.name = [col.name];
				}

				// Template
				if (col.template !== null) {
					for (var name in col.template.params) {
						col.template.params[name] = this.normalizeColumn(col.template.params[name]);
					}
				}

				return col;
			},
			normalizeValue(val, col) {
				// Translate
				if (col.translation !== null) {
					val = col.translation[val];
				}

				// Filter
				if (col.filter !== null) {
					val = this.$options.filters[col.filter](val);
				}

				// Prefix, suffix
				return col.prefix + val + col.suffix;
			},
			normalizeData(item, col) {
				var data;
				var pivot = item;

				if (pivot === null) {
					data = null;
				} else if (col.data !== null) {
					data = typeof col.data == 'function' ? col.data(item) : col.data;
				} else {	
					for (var i in col.name) {
						if (pivot && pivot.hasOwnProperty(col.name[i])) {
							pivot = pivot[col.name[i]];
						} else {
							pivot = null;
							break;
						}
					}

					data = pivot;
				}

				if (data === null || data == '') {
					return col.default;
				}

				if (Array.isArray(data)) {
					for (var i = 0; i < data.length; ++i) {
						data[i] = this.normalizeValue(data[i], col);
					}

					return data;
				} else {
					return this.normalizeValue(data, col);
				}
			},
			normalizeItem(item) {
				var r = [];
				var colData;
				var col;

				for (var i = 0; i < this._columns.length; ++i) {
					colData = {};

					col = this._columns[i];
					colData[col.name] = this.normalizeData(item, col);

					// Template
					if (col.template !== null) {
						for (var name in col.template.params) {
							colData[name] = this.normalizeData(item, col.template.params[name]);
						}
					}

					r.push(colData);
				}

				return r;
			}
		},
		created() {
			console.log(this.columns, this.items);
		}
	}
</script>

<style lang="scss" scoped>
	.new-table-view {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 60px 1fr;
		position: relative;

		& .button {
			background-color: #F7F7F7;
			color: black;
		}

		& > .header {
			display: grid;
			grid-template-rows: 60px;
			border-bottom: 4px solid #f0f0f0;

			& > .column {
				white-space: nowrap; 
				overflow: hidden;
				text-overflow: ellipsis;
				min-width: 0;
				min-height: 0;
				line-height: 60px;
				padding-right: 30px;
				font-size: 14px;
				font-weight: bold;

				&.slim {
					padding-right: 0px;
					font-size: 12px;
				}

				&:first-child {
					padding-left: 30px;
				}
			}
		}

		& > .state {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			display: grid;
			justify-items: center;
			align-items: center;

			color: #A3A3A3;
			font-size: 18px;
		}

		& > .body {
			position: relative;
			display: grid;
			grid-template-columns: 1fr;
			grid-template-rows: repeat(auto-fill, 66px);
			min-width: 0;
			min-height: 0;
			overflow-x: hidden;
			overflow-y: auto;


			


			& > * > .item {
				display: grid;
				cursor: pointer;
				border-top: 1px solid #f0f0f0;

				/*transition: background-color 0s linear 1s ! important;*/
				

				&:first-child {
					border-top: none;
				}

				&:hover {
					background-color: #f7f7f7;
				}




				




			
				& > .cell {
					white-space: nowrap; 
					overflow: hidden;
					text-overflow: ellipsis;
					min-width: 0;
					min-height: 0;
					line-height: 66px;
					padding-right: 30px;					
					font-size: 16px;
					height: 66px;

					&.slim {
						padding-right: 0px;
						font-size: 12px;
					}

					&:first-child {
						padding-left: 30px;
					}

					& > .leave {
						& > span {
							color: white;
							font-size: 12px;
							padding: 2px 3px 2px 3px;
							border-radius: 3px;
							width: 34px;
							display: block;
							line-height: 20px;
							margin: auto;
							margin-top: 20px;
						}
					}

					& > .status {
						position: relative;
						display: grid;

						& > .dot {
							width: 10px;
							height: 10px;
							position: absolute;
							border-radius: 50%;
							top: 28px;
							left: 0;
						}

						& > span {
							padding-left: 20px;
							white-space: nowrap; 
							overflow: hidden;
							text-overflow: ellipsis;
						}

						&.subtitle {
							grid-template-rows: 1fr 1fr;
							height: 66px;
							grid-row-gap: 4px;

							& > .title {
								line-height: normal;
								align-self: end;
								font-size: 14px;
							}

							& > .subtitle {
								align-self: start;
								line-height: normal;
								font-size: 12px;
								color: #a7a7a7;
							}
						}
					}

					& > .profile {
						display: grid;
						grid-template-columns: 66px 1fr;
						grid-template-rows: 1fr 1fr;
						line-height: normal;
						height: 100%;
						width: 100%;
						grid-row-gap: 4px;

						& > .photo {
							grid-column: 1 / 2;
							grid-row: 1 / 3;
							align-self: center;

							& > img {
								width: 48px;
								height: 48px;
								border-radius: 50%;
							}
						}

						& > .name, & > .title {
							grid-column: 2 / 3;
						}

						& > .name {
							grid-row: 1 / 2;
							align-self: end;
							font-size: 14px;
						}

						& > .title {
							grid-row: 2 / 3;
							align-self: start;
							font-size: 12px;
							color: #a7a7a7;
						}
					}
				}
			}
		}
	}

	.item-enter-active, .item-leave-active {
		transform: translateY(0);
		transition: opacity .25s, transform .25s, background-color 0s;
	}
	
	.item-enter, .item-leave-to /* .fade-leave-active below version 2.1.8 */ {
		transform: translateY('20px');
		opacity: 0;
	}

	.item-leave-to {
		transition-delay: 0ms ! important;
	}
</style>